import { create } from 'zustand';
import ServiceCboOcupacoes from '@/services/ServiceCboOcupacoes';
import { notify } from '@/stores/useToast';

export interface LinhaCboOcupacao {
  [k: string]: string; // satisfaz o constraint Record<string, unknown> do AgnesDataTable
  code: string;
  title: string;
  synonyms: string;
  familyCode: string;
  family: string;
}

interface State {
  lista: LinhaCboOcupacao[];
  total: number;
  page: number;
  size: number;
  busca: string;
  carregando: boolean;
  setBusca: (v: string) => void;
  buscar: () => Promise<void>;
  setPage: (p: number) => Promise<void>;
  setSize: (s: number) => Promise<void>;
}

// o BFF (/cbo/list) devolve code/title/synonyms/family/familyCode; normaliza tudo p/ string.
function norm(r: Record<string, unknown>): LinhaCboOcupacao {
  return {
    code: String(r.code ?? ''),
    title: String(r.title ?? ''),
    synonyms: String(r.synonyms ?? ''),
    familyCode: String(r.familyCode ?? ''),
    family: String(r.family ?? ''),
  };
}

export const useCboOcupacoesStore = create<State>((set, get) => ({
  lista: [],
  total: 0,
  page: 0,
  size: 50,
  busca: '',
  carregando: false,

  setBusca(v) {
    set({ busca: v });
  },

  async buscar() {
    const { busca, page, size } = get();
    set({ carregando: true });
    try {
      // busca por título/ocupação (o /cbo/list filtra por ilike no título).
      const body = busca ? { title: busca } : {};
      const { data } = await ServiceCboOcupacoes.search(body, { page, size });
      set({ lista: (data.content ?? []).map(norm), total: data.totalElements ?? 0 });
    } catch {
      set({ lista: [], total: 0 });
      notify.error('Erro ao carregar as ocupações do CBO.');
    } finally {
      set({ carregando: false });
    }
  },

  async setPage(p) {
    set({ page: p });
    await get().buscar();
  },
  async setSize(s) {
    set({ size: s, page: 0 });
    await get().buscar();
  },
}));
